import { Controller } from '@hotwired/stimulus';

export default class TasksGroupDependentsController extends Controller {
  static targets = ['trigger', 'item'];
}
